import React, { useState, useEffect } from 'react'
import { toPrice } from '@dt/fe-utils'
import { modalLayer, getPercent, useHistoryNew, localStore, getExpireDay } from '@utils'
import { MyCardDetail } from '@cps'
import { find } from '@dt/fe-utils/dist/lodash'
import { decorationMobx } from '@mobxStore'
import CardListModal from './CardListModal'
import './index.scss'

interface IProps {
  cardInfo: IDiyMemberCardStyle;
  cardList: IMemberCardInfo[];
}

const MemberCard: React.FC<IProps> = props => {
  const history = useHistoryNew()
  const { cardInfo, cardList } = props
  const cardIconShow: boolean = !!(cardInfo?.cardIcon?.isShow || typeof cardInfo?.cardIcon?.isShow === 'undefined')
  const codeIconShow: boolean = !!(cardInfo?.codeIcon?.isShow || typeof cardInfo?.codeIcon?.isShow === 'undefined')
  const [showCard, setShowCard] = useState<IMemberCardInfo>(null)

  const changeCard = async () => {
    const card: IMemberCardInfo = await modalLayer(CardListModal, { covers: cardList, cover: showCard }, 'CardListModal')
    setShowCard(card)
    decorationMobx.setDiyMemberCardInfo(card)
    localStore.set('diy_card_choosed', card.cardId)
  }
  const getCode = (e: any) => {
    e.stopPropagation()
    modalLayer(MyCardDetail, { cardInfo: showCard }, 'CardDetail').then((url: any) => {
      history.push(url)
    }, () => { })
  }
  const getMemberMargin = (align: string) => {
    if (align === 'left') {
      return 'flex-start'
    } else if (align === 'center') {
      return 'center'
    } else {
      return 'flex-end'
    }
  }

  useEffect(() => {
    const cardId = localStore.get('diy_card_choosed')
    const data = cardId ? find(cardList, item => item.cardId === cardId) : null
    if (data) {
      setShowCard(data)
      decorationMobx.setDiyMemberCardInfo(data)
    } else {
      const defaultCard = find(cardList, item => item.isDefault) || cardList[0]
      setShowCard(defaultCard)
      decorationMobx.setDiyMemberCardInfo(defaultCard)
      localStore.set('diy_card_choosed', defaultCard.cardId)
    }
  }, [cardInfo])
  return showCard ? (
    <div className='diy-member-card-layout' style={{ color: cardInfo.color }}>
      {
        cardInfo?.layout === 'small' ? (
          <>
            {
              cardInfo.line === 'two' ? (
                <div className='member-card-two'>
                  <div className='member-card-two-block'><span className='title'>{i18n.t('mkt.common.integral')}</span><span className='desc'>{showCard.integral}</span></div>
                  <div className='member-card-two-block'><span className='title'>{i18n.t('mkt.common.balance')}</span><span className='desc'>{toPrice(showCard.balance || 0, 2, false)}</span></div>
                  {showCard.card.isLevel &&
                    <div className='member-card-two-block'>
                      <span className='title'>{i18n.t('mkt.member.grade')}</span>
                      <span className='desc'>LV{showCard.card.level || 1}
                        <span className='benefit-level-block'><span style={{ backgroundColor: cardInfo.color, width: showCard.card?.nextLevelInfo ? `${getPercent(showCard.growth, showCard.card.nextLevelInfo.levelGrowth) || 0}%` : '100%' }} className='benefit-level'></span></span>
                      </span>
                    </div>}
                  <div className='member-card-two-block icon-block'>
                    {
                      cardIconShow && cardList.length > 1 &&
                        <div data-cypid='mmgSwitchMCard' onClick={changeCard} className='icon-box'>
                          {
                            cardInfo.cardIcon.type === 'icon' ? (
                              <i style={{ color: cardInfo.cardIcon.color, fontSize: cardInfo.iconFontSize }} className='iconfont icon-yuyuehuanka-lan'></i>
                            ) : (
                              <img style={{ width: `${cardInfo.iconFontSize}px`, height: `${cardInfo.iconFontSize}px` }} src={cardInfo.cardIcon.value} />
                            )
                          }
                        </div>
                    }
                    {
                      codeIconShow &&
                        <div data-cypid='mmgShowMCardCode' onClick={getCode}>
                          {
                            cardInfo.codeIcon.type === 'icon' ? (
                              <i style={{ color: cardInfo.codeIcon.color, fontSize: cardInfo.iconFontSize }} className='iconfont iconfont icon-QC'></i>
                            ) : (
                              <img style={{ width: `${cardInfo.iconFontSize}px`, height: `${cardInfo.iconFontSize}px` }} src={cardInfo.codeIcon.value} />
                            )
                          }
                        </div>
                    }
                  </div>
                </div>
              ) : (
                <div className='member-card-one'>
                  <div><span className='title'>{i18n.t('mkt.common.integral')}</span><span className='desc'>{showCard.integral}</span></div>
                  <div><span className='title'>{i18n.t('mkt.common.balance')}</span><span className='desc'>{toPrice(showCard.balance || 0, 2, false)}</span></div>
                  {showCard.card.isLevel &&
                    <div className='grade'>
                      <span className='title'>{i18n.t('mkt.member.grade')}</span>
                      <span className='desc'>LV{showCard.card.level || 1}</span>
                      <span className='benefit-level-block'><span style={{ backgroundColor: cardInfo.color, width: showCard.card?.nextLevelInfo ? `${getPercent(showCard.growth, showCard.card.nextLevelInfo.levelGrowth) || 0}%` : '100%' }} className='benefit-level'></span></span>
                    </div>}
                  {
                    cardIconShow && cardList.length > 1 &&
                      <div data-cypid='mmgSwitchMCard' onClick={changeCard}>
                        {
                          cardInfo.cardIcon.type === 'icon' ? (
                            <i style={{ color: cardInfo.cardIcon.color, fontSize: cardInfo.iconFontSize }} className='iconfont icon-yuyuehuanka-lan'></i>
                          ) : (
                            <img style={{ width: `${cardInfo.iconFontSize}px`, height: `${cardInfo.iconFontSize}px` }} src={cardInfo.cardIcon.value} />
                          )
                        }
                      </div>
                  }
                  {
                    codeIconShow &&
                      <div data-cypid='mmgShowMCardCode' className='icon-box' onClick={getCode}>
                        {
                          cardInfo.codeIcon.type === 'icon' ? (
                            <i style={{ color: cardInfo.codeIcon.color, fontSize: cardInfo.iconFontSize }} className='iconfont iconfont icon-QC'></i>
                          ) : (
                            <img style={{ width: `${cardInfo.iconFontSize}px`, height: `${cardInfo.iconFontSize}px` }} src={cardInfo.codeIcon.value} />
                          )
                        }
                      </div>
                  }
                </div>
              )
            }
          </>
        ) : (
          <>
            {
              cardInfo?.nameLayout === 'small'
                ? (
                  <div className='diy-card-name-style'>
                    <div className='diy-card-name-style-info'>
                      <div className='name-style-info-left'>
                        <div className='name-style-info-title'>{i18n.t('mkt.common.balance')}</div>
                        <div><span className='name-style-info-count'>{toPrice(showCard.balance || 0, 2, false)}</span><span> {i18n.t('mkt.member.amountUnit')}</span></div>
                      </div>
                      {
                        (showCard.card?.allowAgainLoad || showCard.card?.allowCustomizeLoad) && (!showCard.expireTime || getExpireDay(showCard.expireTime) > 0) &&
                          <div data-cypid='mmgToRechargeMCard' onClick={() => history.push(`/iCard/cardRecharge/${showCard.memberCardId}`)} className='name-style-info-btn' style={{ backgroundColor: cardInfo.nameStyle?.btnBg, color: cardInfo.nameStyle?.btnColor }}>{i18n.t('mkt.member.rechargeBalance')}</div>
                      }
                    </div>
                    <div className='diy-card-name-style-info'>
                      <div className='name-style-info-left'>
                        <div className='name-style-info-title'>{i18n.t('mkt.common.integral')}</div>
                        <div><span className='name-style-info-count'>{showCard.integral}</span><span> {i18n.t('mkt.member.integralUnit')}</span></div>
                      </div>
                      <div data-cypid='mmgToRedeem' onClick={() => history.push(`/redeem/${showCard.cardId}`)} className='name-style-info-btn' style={{ backgroundColor: cardInfo.nameStyle?.btnBg, color: cardInfo.nameStyle?.btnColor }}>{i18n.t('mkt.coupon.exchange')}</div>
                    </div>
                    <div className='diy-card-name-style-bottom'>
                      <div className='name-style-bottom-title'>
                        {cardInfo.nameStyle?.showName && <span>{showCard.card.cardName}</span>}
                        {cardInfo.nameStyle?.showLevel && showCard.card.isLevel && <span> LV{showCard.card.level || 1}</span>}
                      </div>
                      {
                        cardIconShow && cardList.length > 1 &&
                          <div data-cypid='mmgSwitchMCard' onClick={changeCard}>
                            {
                              cardInfo.cardIcon.type === 'icon' ? (
                                <i style={{ color: cardInfo.cardIcon.color, fontSize: cardInfo.iconFontSize }} className='iconfont icon-yuyuehuanka-lan'></i>
                              ) : (
                                <img style={{ width: `${cardInfo.iconFontSize}px`, height: `${cardInfo.iconFontSize}px` }} src={cardInfo.cardIcon.value} />
                              )
                            }
                          </div>
                      }
                      {
                        codeIconShow &&
                          <div data-cypid='mmgShowMCardCode' className='name-style-bottom-icon' onClick={getCode}>
                            {
                              cardInfo.codeIcon.type === 'icon' ? (
                                <i style={{ color: cardInfo.codeIcon.color, fontSize: cardInfo.iconFontSize }} className='iconfont icon-QC'></i>
                              ) : (
                                <img style={{ width: `${cardInfo.iconFontSize}px`, height: `${cardInfo.iconFontSize}px` }} src={cardInfo.codeIcon.value} />
                              )
                            }
                          </div>
                      }
                    </div>
                  </div>
                ) : (
                  <div className='diy-member-card' style={{ textAlign: cardInfo.align }}>
                    <div className='diy-member-card-name' style={{ fontSize: cardInfo.nameFontSize }}>{showCard.card.cardName}</div>
                    <div className='diy-member-card-benefit'>
                      {
                        cardInfo.align === 'center' ? (
                          <div className='card-benefit-center'>
                            <div><div className='card-benefit-center-title'>{i18n.t('mkt.common.integral')}</div><div className='benefit-desc'>{showCard.integral}</div></div>
                            <div className='center-line'></div>
                            <div><div className='card-benefit-center-title'>{i18n.t('mkt.common.balance')}</div><div className='benefit-desc'>{toPrice(showCard.balance || 0, 2, false)}</div></div>
                            {
                              showCard.card.isLevel &&
                                <>
                                  <div className='center-line'></div>
                                  <div><div className='card-benefit-center-title'>{i18n.t('mkt.member.grade')}</div><div className='benefit-desc'>LV{showCard.card.level || 1}<span className='benefit-level-block'><span style={{ backgroundColor: cardInfo.color, width: showCard.card?.nextLevelInfo ? `${getPercent(showCard.growth, showCard.card.nextLevelInfo.levelGrowth) || 0}%` : '100%' }} className='benefit-level'></span></span></div></div>
                                </>
                            }
                          </div>
                        ) : (
                          <>
                            <span className='benefit-title'>{i18n.t('mkt.common.integral')}</span><span className='benefit-desc'>{showCard.integral}</span>
                            <span className='benefit-line'>|</span>
                            <span className='benefit-title'>{i18n.t('mkt.common.balance')}</span><span className='benefit-desc'>{toPrice(showCard.balance || 0, 2, false)}</span>
                            {
                              showCard.card.isLevel &&
                                <>
                                  <span className='benefit-line'>|</span>
                                  <span className='benefit-title'>{i18n.t('mkt.member.grade')}</span><span className='benefit-desc'>LV{showCard.card.level || 1}<span className='benefit-level-block'><span style={{ backgroundColor: cardInfo.color, width: showCard.card?.nextLevelInfo ? `${getPercent(showCard.growth, showCard.card.nextLevelInfo.levelGrowth) || 0}%` : '100%' }} className='benefit-level'></span></span></span>
                                </>
                            }
                          </>
                        )
                      }
                    </div>
                    <div className='diy-member-card-icon' style={{ justifyContent: getMemberMargin(cardInfo.align) }}>
                      {
                        cardIconShow && cardList.length > 1 &&
                          <div data-cypid='mmgSwitchMCard' onClick={changeCard}>
                            {
                              cardInfo.cardIcon.type === 'icon' ? (
                                <i style={{ color: cardInfo.cardIcon.color, fontSize: cardInfo.iconFontSize }} className='iconfont icon-yuyuehuanka-lan'></i>
                              ) : (
                                <img style={{ width: `${cardInfo.iconFontSize}px`, height: `${cardInfo.iconFontSize}px` }} src={cardInfo.cardIcon.value} />
                              )
                            }
                          </div>
                      }
                      {
                        cardIconShow && cardList.length > 1 && codeIconShow && <div className='icon-line'></div>
                      }
                      {
                        codeIconShow &&
                          <div data-cypid='mmgShowMCardCode' onClick={getCode}>
                            {
                              cardInfo.codeIcon.type === 'icon' ? (
                                <i style={{ color: cardInfo.codeIcon.color, fontSize: cardInfo.iconFontSize }} className='iconfont icon-QC'></i>
                              ) : (
                                <img style={{ width: `${cardInfo.iconFontSize}px`, height: `${cardInfo.iconFontSize}px` }} src={cardInfo.codeIcon.value} />
                              )
                            }
                          </div>
                      }
                    </div>
                  </div>
                )
            }
          </>
        )
      }
    </div>
  ) : <></>
}

export default MemberCard
